import IbssTextField from '../../../../../Components/Inputs/TextField/IbssTextField';
import IbssCheckBox from '../../../../../Components/Inputs/CheckBox/IbssCheckBox';
import { appContext } from '../../../../../AppContext';
import { IbssComponent } from '../../../../../Components/Core/BaseComponent/IbssComponent';

class PolicyQuestionForm extends IbssComponent<IProps, IState>
{

    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    };

    public render(): JSX.Element
    {
        return (
            <div>
                <div className='m-4'>
                    <IbssTextField required value={this.props.policyName} className='mb-1' fullWidth variant='standard' label={this.labels.funcVisitorTypesPolicyName_S} onChange={(e) => this.props.onPolicyNameChange(e.target.value)} />
                    <IbssTextField required multiline value={this.props.policyText} className='mb-1' fullWidth variant='outlined' label={this.labels.funcVisitorTypesPolicyText_S} onChange={(e) => this.props.onPolicyTextChange(e.target.value)} />
                </div>
                <hr />
                <div className='m-4'>
                    <div className='mb-1'>
                        <IbssCheckBox checked={this.props.requiredConfirmation} label={this.labels.funcVisitorTypesRequiredConfirmation_S} onClicked={(e: { target: { checked: boolean; }; }) => this.props.onRequiredConfirmationChange(e.target.checked)} />
                    </div>
                    <IbssTextField value={this.props.confirmationText} className='mb-1' fullWidth variant='standard' label={this.labels.funcVisitorTypesConfirmationText_S} onChange={(e) => this.props.onConfirmationTextChange(e.target.value)} />
                </div>
            </div>
        )
    }
}

export default PolicyQuestionForm;

export interface IProps
{
    onPolicyNameChange: (value: string) => void;
    policyName: string;
    onPolicyTextChange: (value: string) => void;
    policyText: string
    onRequiredConfirmationChange: (value: boolean) => void;
    requiredConfirmation: boolean
    onConfirmationTextChange: (value: string) => void;
    confirmationText: string;
}

export interface IState
{
}